<template>
  <div>
    <div class="bg-gray-100 text-white relative z-10" :style="styles">
      <div class="container relative z-20 full">
        <div class="flex flex-col h-40">
          <h1 class="fs-20 mt-auto mb-0">
            <span
              class="inline-block bg-white text-gray-800 py-2 px-4 rounded-t-lg"
              >Danh sách đơn hàng</span
            >
          </h1>
        </div>
      </div>
    </div>
    <div class="container text-gray-800 full">
      <div class="py-4">
        <div class="row">
          <div class="col-md-2">
            <div class="mb-2">
              <form @submit.prevent="handleSearchOrders">
                <el-input
                  class="hodo-el-input"
                  placeholder="Nhập mã đơn hàng"
                  v-model="searchInput"
                  clearable
                  @keyup.enter="handleSearchOrders"
                >
                  <i
                    slot="prefix"
                    @click.prevent="handleSearchOrders"
                    class="el-input__icon el-icon-search cursor-pointer"
                  ></i>
                </el-input>
              </form>
            </div>
            <div
              role="button"
              class="py-2 px-2 text-sm border mb-2 rounded-md"
              :class="index === activeFilter ? 'bg-blue-200' : ''"
              v-for="(item, index) in filters"
              :key="index"
              @click.prevent="handleActiveFilter(index)"
            >
              <span>{{ item }}</span>
              <span>{{ getTotal(index) }}</span>
            </div>
          </div>
          <div class="col-md-10">
            <el-table
              :data="invoicesData"
              style="width: 100%"
              class="cs-table"
              header-row-class-name="text-gray-900"
              header-cell-class-name="whitespace-nowrap"
              row-class-name="cursor-pointer"
              :default-expand-all="false"
              @row-click="viewDetailOrder"
            >
              <!-- <el-table-column label type="expand">
                <template slot-scope="props">
                  <div
                    class="flex items-center group pl-9"
                    :class="
                      index < props.row.order_items.length - 1
                        ? 'border-b border-t-0 border-r-0 border-l-0 border-solid border-gray-200 mb-1 pb-1'
                        : ''
                    "
                    v-for="(item, index) in props.row.order_items"
                    :key="`order-invoice-${item.id}-${index}`"
                    @click.stop
                  >
                    <img
                      class="h-10 mr-2 cursor-pointer"
                      :src="item.product.primary_image"
                      :alt="item.product.name"
                      @click="
                        $router.push({
                          path: `/ecommerce/${item.product.slug}`,
                        })
                      "
                    />
                    <div>
                      <h2
                        class="fs-14 mb-0 group-hover:text-blue-700 transition-all duration-300 cursor-pointer"
                        @click="
                          $router.push({
                            path: `/ecommerce/${item.product.slug}`,
                          })
                        "
                      >
                        {{ item.product.name }}
                      </h2>
                      <div class="text-blue-700">
                        {{ appUtils.numberFormat(item.price) }} VNĐ x
                        {{ item.qty }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column> -->
              <el-table-column label="Đặt hàng lúc" width="180">
                <template slot-scope="props">
                  <i class="el-icon-time"></i>
                  <span style="margin-left: 10px">{{
                    appUtils.formatTimeDate(props.row.created_at)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Mã đơn hàng" width="150">
                <template slot-scope="props">
                  <span class="fw-500 text-blue-700"
                    >#{{ props.row.order_code }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="Trạng thái đơn hàng" width="180">
                <template slot-scope="props">
                  <div
                    class="flex items-center"
                    :set="(status = getOrderStatus(props.row.status))"
                  >
                    <span
                      :class="status.classes"
                      class="flex text-sm border rounded-full w-6 h-6"
                    >
                      <i class="m-auto" :class="status.icon" />
                    </span>
                    <span class="ml-2">{{
                      $t(
                        Object.keys(ORDERS_STATUS)[
                          props.row.status === 0 ? 0 : props.row.status - 1
                        ]
                      )
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Phương thức thanh toán" width="250">
                <template slot-scope="props">
                  <div
                    v-if="props.row.payment_method === 2"
                    class="whitespace-nowrap"
                  >
                    <span class="px-2">Thanh toán online</span>

                    <span class="inline-block w-8 leading-none">
                      <svg
                        width="24"
                        height="32"
                        viewBox="0 0 256 199"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M46.54 198.011V184.84c0-5.05-3.074-8.342-8.343-8.342c-2.634 0-5.488.878-7.464 3.732c-1.536-2.415-3.731-3.732-7.024-3.732c-2.196 0-4.39.658-6.147 3.073v-2.634h-4.61v21.074h4.61v-11.635c0-3.731 1.976-5.488 5.05-5.488c3.072 0 4.61 1.976 4.61 5.488v11.635h4.61v-11.635c0-3.731 2.194-5.488 5.048-5.488c3.074 0 4.61 1.976 4.61 5.488v11.635zm68.271-21.074h-7.463v-6.366h-4.61v6.366h-4.171v4.17h4.17v9.66c0 4.83 1.976 7.683 7.245 7.683c1.976 0 4.17-.658 5.708-1.536l-1.318-3.952c-1.317.878-2.853 1.098-3.951 1.098c-2.195 0-3.073-1.317-3.073-3.513v-9.44h7.463zm39.076-.44c-2.634 0-4.39 1.318-5.488 3.074v-2.634h-4.61v21.074h4.61v-11.854c0-3.512 1.536-5.488 4.39-5.488c.878 0 1.976.22 2.854.439l1.317-4.39c-.878-.22-2.195-.22-3.073-.22m-59.052 2.196c-2.196-1.537-5.269-2.195-8.562-2.195c-5.268 0-8.78 2.634-8.78 6.805c0 3.513 2.634 5.488 7.244 6.147l2.195.22c2.415.438 3.732 1.097 3.732 2.195c0 1.536-1.756 2.634-4.83 2.634c-3.073 0-5.488-1.098-7.025-2.195l-2.195 3.512c2.415 1.756 5.708 2.634 9 2.634c6.147 0 9.66-2.853 9.66-6.805c0-3.732-2.854-5.708-7.245-6.366l-2.195-.22c-1.976-.22-3.512-.658-3.512-1.975c0-1.537 1.536-2.415 3.951-2.415c2.635 0 5.269 1.097 6.586 1.756zm122.495-2.195c-2.635 0-4.391 1.317-5.489 3.073v-2.634h-4.61v21.074h4.61v-11.854c0-3.512 1.537-5.488 4.39-5.488c.879 0 1.977.22 2.855.439l1.317-4.39c-.878-.22-2.195-.22-3.073-.22m-58.833 10.976c0 6.366 4.39 10.976 11.196 10.976c3.073 0 5.268-.658 7.463-2.414l-2.195-3.732c-1.756 1.317-3.512 1.975-5.488 1.975c-3.732 0-6.366-2.634-6.366-6.805c0-3.951 2.634-6.586 6.366-6.805c1.976 0 3.732.658 5.488 1.976l2.195-3.732c-2.195-1.757-4.39-2.415-7.463-2.415c-6.806 0-11.196 4.61-11.196 10.976m42.588 0v-10.537h-4.61v2.634c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976c0 6.366 4.61 10.976 10.537 10.976c3.073 0 5.269-1.097 6.586-3.073v2.634h4.61zm-16.904 0c0-3.732 2.415-6.805 6.366-6.805c3.732 0 6.367 2.854 6.367 6.805c0 3.732-2.635 6.805-6.367 6.805c-3.951-.22-6.366-3.073-6.366-6.805m-55.1-10.976c-6.147 0-10.538 4.39-10.538 10.976c0 6.586 4.39 10.976 10.757 10.976c3.073 0 6.147-.878 8.562-2.853l-2.196-3.293c-1.756 1.317-3.951 2.195-6.146 2.195c-2.854 0-5.708-1.317-6.367-5.05h15.587v-1.755c.22-6.806-3.732-11.196-9.66-11.196m0 3.951c2.853 0 4.83 1.757 5.268 5.05h-10.976c.439-2.854 2.415-5.05 5.708-5.05m114.372 7.025v-18.879h-4.61v10.976c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976c0 6.366 4.61 10.976 10.537 10.976c3.074 0 5.269-1.097 6.586-3.073v2.634h4.61zm-16.903 0c0-3.732 2.414-6.805 6.366-6.805c3.732 0 6.366 2.854 6.366 6.805c0 3.732-2.634 6.805-6.366 6.805c-3.952-.22-6.366-3.073-6.366-6.805m-154.107 0v-10.537h-4.61v2.634c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976c0 6.366 4.61 10.976 10.537 10.976c3.074 0 5.269-1.097 6.586-3.073v2.634h4.61zm-17.123 0c0-3.732 2.415-6.805 6.366-6.805c3.732 0 6.367 2.854 6.367 6.805c0 3.732-2.635 6.805-6.367 6.805c-3.951-.22-6.366-3.073-6.366-6.805"
                        />
                        <path
                          fill="#FF5F00"
                          d="M93.298 16.903h69.15v124.251h-69.15z"
                        />
                        <path
                          fill="#EB001B"
                          d="M97.689 79.029c0-25.245 11.854-47.637 30.074-62.126C114.373 6.366 97.47 0 79.03 0C35.343 0 0 35.343 0 79.029c0 43.685 35.343 79.029 79.029 79.029c18.44 0 35.343-6.366 48.734-16.904c-18.22-14.269-30.074-36.88-30.074-62.125"
                        />
                        <path
                          fill="#F79E1B"
                          d="M255.746 79.029c0 43.685-35.343 79.029-79.029 79.029c-18.44 0-35.343-6.366-48.734-16.904c18.44-14.488 30.075-36.88 30.075-62.125c0-25.245-11.855-47.637-30.075-62.126C141.373 6.366 158.277 0 176.717 0c43.686 0 79.03 35.563 79.03 79.029"
                        />
                      </svg>
                    </span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 256 83"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <defs>
                        <linearGradient
                          id="logosVisa0"
                          x1="45.974%"
                          x2="54.877%"
                          y1="-2.006%"
                          y2="100%"
                        >
                          <stop offset="0%" stop-color="#222357" />
                          <stop offset="100%" stop-color="#254AA5" />
                        </linearGradient>
                      </defs>
                      <path
                        fill="url(#logosVisa0)"
                        d="M132.397 56.24c-.146-11.516 10.263-17.942 18.104-21.763c8.056-3.92 10.762-6.434 10.73-9.94c-.06-5.365-6.426-7.733-12.383-7.825c-10.393-.161-16.436 2.806-21.24 5.05l-3.744-17.519c4.82-2.221 13.745-4.158 23-4.243c21.725 0 35.938 10.724 36.015 27.351c.085 21.102-29.188 22.27-28.988 31.702c.069 2.86 2.798 5.912 8.778 6.688c2.96.392 11.131.692 20.395-3.574l3.636 16.95c-4.982 1.814-11.385 3.551-19.357 3.551c-20.448 0-34.83-10.87-34.946-26.428m89.241 24.968c-3.967 0-7.31-2.314-8.802-5.865L181.803 1.245h21.709l4.32 11.939h26.528l2.506-11.939H256l-16.697 79.963zm3.037-21.601l6.265-30.027h-17.158zm-118.599 21.6L88.964 1.246h20.687l17.104 79.963zm-30.603 0L53.941 26.782l-8.71 46.277c-1.022 5.166-5.058 8.149-9.54 8.149H.493L0 78.886c7.226-1.568 15.436-4.097 20.41-6.803c3.044-1.653 3.912-3.098 4.912-7.026L41.819 1.245H63.68l33.516 79.963z"
                        transform="matrix(1 0 0 -1 0 82.668)"
                      />
                    </svg>
                  </div>
                  <div v-else class="whitespace-nowrap">
                    <span class="px-2">Thanh toán trực tiếp</span>

                    <span class="inline-block w-6 h-6 leading-none">
                      <svg
                        viewBox="0 0 42 42"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_223_2579)">
                          <rect width="42" height="42" rx="21" fill="white" />
                          <rect
                            x="3.69141"
                            y="9.91797"
                            width="36.3083"
                            height="25.0895"
                            rx="2.65173"
                            fill="white"
                          />
                          <rect
                            x="3.69141"
                            y="9.91797"
                            width="18.1542"
                            height="25.0895"
                            rx="2.65173"
                            fill="#F39D56"
                          />
                          <rect
                            x="21.8457"
                            y="9.91797"
                            width="18.1542"
                            height="25.0895"
                            rx="2.65173"
                            fill="#FDF4D9"
                          />
                          <rect
                            x="27.7612"
                            y="9.91797"
                            width="6.11938"
                            height="5.9154"
                            fill="#F39D56"
                          />
                          <rect
                            x="26.5371"
                            y="24.8085"
                            width="8.56713"
                            height="4.28357"
                            fill="white"
                          />
                          <rect
                            x="27.7612"
                            y="25.8284"
                            width="6.11938"
                            height="2.24377"
                            fill="#F39D56"
                          />
                          <path
                            d="M3.69141 22.1567L12.6665 14.4055V23.2786L19.8058 24.7065V35.0074H6.34314C4.87863 35.0074 3.69141 33.8202 3.69141 32.3557V22.1567Z"
                            fill="#E1863A"
                          />
                          <path
                            d="M5.01739 19.709C3.30396 20.5249 0.291869 19.029 -1 18.1791L-0.796021 25.4204C0.611225 25.379 1.93799 25.6683 3.01918 26.0433C4.62172 26.5992 6.21435 27.3796 7.4524 28.5391C9.48251 30.4403 11.5588 33.5866 12.1567 33.8855C12.8094 34.2119 12.8366 33.7496 12.7686 33.4776C11.9867 32.2877 10.382 29.704 10.2189 28.888C10.0557 28.0721 10.6268 28.2081 10.9328 28.3781C12.5646 29.364 15.9915 31.4582 16.6442 31.9477C16.8296 32.0868 16.9919 32.1742 17.1316 32.2251C17.5464 32.3761 17.7432 31.9006 17.4755 31.5498C16.5833 30.3804 13.8535 28.3722 12.3606 27.3582C11.5447 26.3791 12.4286 26.5423 12.9726 26.7463L17.8465 28.6463C18.6022 28.9409 20.2023 29.2386 19.7699 28.5523C19.6209 28.3158 19.2795 28.051 18.99 27.8682L14.0955 25.5544C13.6237 25.3314 12.8607 24.9679 13.1241 24.5174C13.2207 24.3521 13.4844 24.2985 13.6865 24.2985C15.1824 24.6385 18.4596 25.2572 19.6019 25.0124C19.8501 24.9593 20.0129 24.8923 20.1108 24.8176C20.7276 24.3471 19.2232 23.8948 18.472 23.701L16.4402 23.1766C14.7404 22.6667 11.1572 21.3408 10.4228 20.1169C9.87269 19.2 10.6239 18.035 11.4071 17.2224C11.8712 16.7408 12.4024 16.2875 12.6333 15.6597C12.847 15.0787 12.7661 14.678 12.5695 14.4144C12.256 13.9941 11.6521 14.2572 11.3205 14.6634C8.76143 17.7983 7.02365 18.7536 5.01739 19.709Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_223_2579">
                            <rect width="42" height="42" rx="21" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label width="120">
                <template slot-scope="props">
                  <div class="text-right" @click.stop>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="Xem chi tiết đơn hàng"
                      placement="top"
                    >
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-view"
                        @click.prevent="viewDetailOrder(props.row)"
                      ></el-button>
                    </el-tooltip>
                    <!-- <el-tooltip
                      class="item"
                      effect="dark"
                      content="Hủy đơn hàng"
                      placement="top"
                    >
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-error"
                        v-if="
                          props.row.status === ORDERS_STATUS.RECEIVE_ORDERS ||
                          props.row.status === ORDERS_STATUS.WAITING_CONFIRM
                        "
                        @click.prevent="deleteOrder(props.row.id)"
                      ></el-button>
                    </el-tooltip> -->
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div
              class="flex justify-center mt-3"
              v-if="totalItems > DEFAULT_SIZE_OF_PAGE"
            >
              <el-pagination
                background
                layout="prev, pager, next"
                :pager-count="5"
                :page-size="DEFAULT_SIZE_OF_PAGE"
                :total="totalItems"
                class="el-pagination-orders p-0"
                @next-click="handleChangePage"
                @prev-click="handleChangePage"
                @current-change="handleChangePage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import bgImage from '../../assets/bg3.jpg'
import { ORDERS_STATUS } from '../../utils/constant'
import { mapState } from 'vuex'

export default {
  name: 'Orders',
  data () {
    return {
      appUtils,
      ordersData: [],
      invoices: [],
      invoicesData: [],
      waitingOrders: [],
      finishedOrders: [],
      canceledOrders: [],
      styles: {
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        backgroundPosition: 'center'
      },
      ORDERS_STATUS,
      DEFAULT_SIZE_OF_PAGE: 10000,
      totalItems: 0,
      activeFilter: 0,
      filters: [
        'Đang chờ hàng',
        'Đơn đã hoàn thành',
        'Đơn hàng đã hủy',
        'Tất cả đơn hàng'
      ],
      searchInput: ''
    }
  },
  created () {
    if (!this.$user) return

    this.getInvoicesData()
  },
  computed: {
    ...mapState({
      orders: (state) => {
        return state.ecommerce.orders
      }
    })
  },
  methods: {
    getInvoicesData () {
      // const data = appUtils.getInvoices(this.$user.id)
      const params = {
        sort_by: 'created_at',
        order: 'desc',
        page_size: this.DEFAULT_SIZE_OF_PAGE,
        page_num: 1
      }
      this.$store
        .dispatch('ecommerce/getECommerceOrders', params)
        .then((res) => {
          if (res?.success) {
            this.makeInvoices()
          }
        })
    },
    makeInvoices () {
      this.orderData = [...this.orders?.data]

      // eslint-disable-next-line no-unused-expressions
      const newOrderData = this.orderData?.map((order) => {
        return {
          ...order
        }
      })

      this.invoices = newOrderData

      this.waitingOrders = newOrderData.filter(
        (item) =>
          item.status < ORDERS_STATUS.FINISHED ||
          item.status === ORDERS_STATUS.WAITING_CONFIRM
      )
      this.finishedOrders = newOrderData.filter(
        (item) => item.status === ORDERS_STATUS.FINISHED
      )
      this.canceledOrders = newOrderData.filter(
        (item) =>
          item.status === ORDERS_STATUS.CANCELED ||
          item.status === ORDERS_STATUS.ERROR_PAYMENT
      )
      this.handleActiveFilter(this.activeFilter)
    },
    viewDetailOrder (record) {
      if (record.status === ORDERS_STATUS.WAITING_CONFIRM) {
        this.$router.push({
          name: 'OrderConfirm',
          params: {
            id: record.id
          }
        })
        return
      }
      this.$router.push({
        name: 'ProductOrderInvoice',
        params: {
          id: record.id
        }
      })
    },
    async deleteOrder (orderId) {
      const data = this.invoices.find((invoice) => invoice.id === orderId)

      if (data.order_processor_status > 1) {
        this.$message({
          type: 'error',
          message: 'Đơn hàng đang được xử lý, không thể huỷ đơn hàng.'
        })
        return
      }

      if (!data || typeof data === 'undefined') return

      let _confirm = null
      _confirm = await this.$confirm(
        this.$t('Bạn chắc chắn muốn hủy đơn hàng?'),
        'Cảnh báo'
      ).catch((_) => {})

      if (!_confirm) return

      data.status = ORDERS_STATUS.CANCELED

      appUtils.setInvoices(this.invoices, this.$user.id)

      await this.$rf.getRequest('GuestRequest').putCancelOrder(Number(orderId))

      this.$message({
        type: 'success',
        message: 'Hủy đơn hàng thành công'
      })
      this.getInvoicesData()
    },
    getOrderStatus (status) {
      switch (status) {
        case 0:
        case ORDERS_STATUS.RECEIVE_ORDERS:
          return {
            classes: 'bg-blue-700 text-white',
            icon: 'el-icon-loading'
          }
        case ORDERS_STATUS.PROCESSING:
          return {
            classes: 'bg-blue-700 text-white',
            icon: 'el-icon-loading'
          }
        case ORDERS_STATUS.SENDING:
          return {
            classes: 'bg-blue-700 text-white',
            icon: 'el-icon-loading'
          }
        case ORDERS_STATUS.FINISHED:
          return {
            classes: 'bg-green-500 text-white',
            icon: 'el-icon-check'
          }
        case ORDERS_STATUS.CANCELED:
          return {
            classes: 'bg-red-500 text-white',
            icon: 'el-icon-close'
          }
        case ORDERS_STATUS.WAITING_CONFIRM:
          return {
            classes: 'bg-gray-300 text-gray-900',
            icon: 'el-icon-more'
          }
        case ORDERS_STATUS.ERROR_PAYMENT:
          return {
            classes: 'bg-red-500 text-white',
            icon: 'el-icon-close'
          }

        default:
          return {
            classes: 'bg-white',
            icon: ''
          }
      }
    },
    handleChangePage (newPage) {
      switch (this.activeFilter) {
        case 0:
          this.invoicesData = this.waitingOrders.slice(
            (newPage - 1) * this.DEFAULT_SIZE_OF_PAGE,
            newPage * this.DEFAULT_SIZE_OF_PAGE
          )
          break
        case 1:
          this.invoicesData = this.finishedOrders.slice(
            (newPage - 1) * this.DEFAULT_SIZE_OF_PAGE,
            newPage * this.DEFAULT_SIZE_OF_PAGE
          )
          break
        case 2:
          this.invoicesData = this.canceledOrders.slice(
            (newPage - 1) * this.DEFAULT_SIZE_OF_PAGE,
            newPage * this.DEFAULT_SIZE_OF_PAGE
          )
          break
        default:
          this.invoicesData = this.invoices.slice(
            (newPage - 1) * this.DEFAULT_SIZE_OF_PAGE,
            newPage * this.DEFAULT_SIZE_OF_PAGE
          )
          break
      }
    },
    handleActiveFilter (index) {
      this.activeFilter = index

      switch (index) {
        case 0:
          this.invoicesData = this.waitingOrders
          this.totalItems = this.waitingOrders?.length
          this.handleChangePage(1)
          break
        case 1:
          this.invoicesData = this.finishedOrders
          this.totalItems = this.finishedOrders?.length
          this.handleChangePage(1)
          break
        case 2:
          this.invoicesData = this.canceledOrders
          this.totalItems = this.canceledOrders?.length
          this.handleChangePage(1)
          break
        default:
          this.invoicesData = this.invoices
          this.totalItems = this.invoices?.length
          this.handleChangePage(1)
          break
      }
    },
    handleSearchOrders () {
      if (!this.searchInput || this.searchInput === '') return

      let data = null
      const filterData = (invoices) => {
        data = invoices.filter((item) => item.order_code === this.searchInput)
        if (!data || !data.length) {
          this.$message({
            type: 'warning',
            message: `Không tìm thấy mã đơn hàng: #${this.searchInput}`
          })
          return
        }
        this.invoicesData = [...data]
      }

      switch (this.activeFilter) {
        case 0:
          filterData(this.waitingOrders)
          break
        case 1:
          filterData(this.finishedOrders)
          break
        case 2:
          filterData(this.canceledOrders)
          break
        default:
          filterData(this.invoices)
          break
      }
    },
    getTotal (index) {
      let totalItems = 0

      switch (index) {
        case 0:
          totalItems = this.waitingOrders?.length
          break
        case 1:
          totalItems = this.finishedOrders?.length
          break
        case 2:
          totalItems = this.canceledOrders?.length
          break
        default:
          totalItems = this.invoices?.length
          break
      }
      return `(${totalItems})`
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .hodo-el-input {
    &.el-input--suffix .el-input__inner {
      padding-right: 8px;
    }
  }

  .cs-table {
    height: 630px;
    overflow-y: scroll;
  }
}
</style>
